<template>
<v-container fluid class="ma-0 pa-0">
<v-layout row wrap>
  <v-flex xs12 class="mb-3"><h1>Trackers</h1></v-flex>
  <v-flex xs12>
    <v-data-table
      :headers="headers"
      :items="trackers"
      :pagination.sync="pagination"
      :total-items="trackers.length"
      :loading="ui.loading"
      class="elevation-1"
      :rows-per-page-items="[1]"
    >
      <v-progress-linear slot="progress" :color="isDark ? 'white' : 'primary'" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr @click="setDetails(props.item)" style="cursor:pointer;">
        <td>{{ props.item.tracking_code }}</td>
        <td class="text-xs-center">{{ props.item.carrier }}</td>
        <td class="text-xs-center">{{ props.item.status | toUpperCase}}</td>
        <td class="text-xs-center">
            <v-icon v-if="props.item.label.is_return_label">check</v-icon>
        </td>
        <td class="text-xs-center">{{ props.item.est_delivery_date | toTimestamp }}</td>
        <td class="text-xs-right">{{ props.item.timestamp | toTimestamp }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
</v-layout>

<v-dialog v-model="ui.dialog" v-if="details">
  <v-card>
    <v-toolbar tabs>
      <v-toolbar-title>{{details.tracking_code}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <span>
        {{details.status | toUpperCase}}
        <v-btn small v-if="details.status !== 'VOIDED'" :loading="ui.voiding" @click="voidTrackingLabel(details)" class="red ml-3">VOID LABEL</v-btn>
      </span>

      <v-tabs slot="extension" v-model="ui.tab" centered grow color="transparent">
        <v-tabs-slider></v-tabs-slider>
        <v-tab>History</v-tab>
        <v-tab>Draft</v-tab>
        <v-tab>Items</v-tab>
        <v-tab v-if="details.is_return">Returns</v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items v-model="ui.tab">
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-timeline
              v-if="!ui.loading"
              align-top
              dense                  
            >
              <v-timeline-item
                v-for="(detail, i) in details.tracking_details"
                :key="i"
                small
                :color="isDark ? 'white' : 'primary'"   
              >
                <v-layout pt-3>
                  <v-flex xs3>
                    <strong>{{detail.datetime | toTimestamp}}</strong>
                  </v-flex>
                  <v-flex>
                    <strong>{{detail.message}}</strong>
                    <div class="caption">{{detail.tracking_location.city}} {{detail.tracking_location.state}} {{detail.tracking_location.zip}}
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
              <v-container v-if="!ui.loading" grid-list-sm class="ma-0 pa-0">
                <v-layout row wrap>
                  <v-flex xs12 sm8>
                    <v-layout row wrap>
                      <v-flex xs12 sm6><v-text-field label="First Name" :value="details.draft.customer.first_name" box readonly hide-details></v-text-field></v-flex>
                      <v-flex xs12 sm6><v-text-field label="Last Name" :value="details.draft.customer.last_name" box readonly hide-details></v-text-field></v-flex>
                      <v-flex xs12 sm12><v-text-field label="Email" :value="details.draft.customer.email" box readonly hide-details></v-text-field></v-flex>
                      <v-flex xs12 sm12><v-text-field label="Address" :value="details.draft.customer.default_address.address1" box readonly hide-details></v-text-field></v-flex>
                      <v-flex xs12 sm12><v-text-field label="Address 2" :value="details.draft.customer.default_address.address2" box readonly hide-details></v-text-field></v-flex>
                      <v-flex xs12 sm4><v-text-field label="City" :value="details.draft.customer.default_address.city" box readonly hide-details></v-text-field></v-flex>
                      <v-flex xs12 sm4><v-text-field label="State" :value="details.draft.customer.default_address.province" box readonly hide-details></v-text-field></v-flex>
                      <v-flex xs12 sm4><v-text-field label="Zip" :value="details.draft.customer.default_address.zip" box readonly hide-details></v-text-field></v-flex>
                      <v-flex xs12 sm12><v-text-field label="Country" :value="details.draft.customer.default_address.country" box readonly hide-details></v-text-field></v-flex>
                      <v-flex xs12 sm12 v-if="details.draft.customer.default_address.phone"><v-text-field label="Phone" :value="details.draft.customer.default_address.phone" box readonly hide-details></v-text-field></v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-list class="pt-0 subscriber-details" style="background:transparent!important;">
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>Draft ID</v-list-tile-title>
                          <v-list-tile-sub-title>{{details.draft.id}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>Account ID</v-list-tile-title>
                          <v-list-tile-sub-title>{{details.draft.customer.id}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>Box ID</v-list-tile-title>
                          <v-list-tile-sub-title>{{details.draft.box_id}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>Subscription ID</v-list-tile-title>
                          <v-list-tile-sub-title>{{details.draft.subscription_id}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>Subscription Product ID</v-list-tile-title>
                          <v-list-tile-sub-title>{{details.draft.subscription_product_id}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>Subscription Product SKU</v-list-tile-title>
                          <v-list-tile-sub-title>{{details.draft.subscription_product_sku}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>Is Return Tracking Label</v-list-tile-title>
                          <v-list-tile-sub-title>{{details.is_return ? 'Yes' : 'No'}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-flex>
                </v-layout>
              </v-container>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-data-table
                  v-if="!ui.loading"
                  :headers="line_item_headers"
                  :items="details.draft.line_items"
                  :loading="ui.loading"
                  :hide-actions="details.draft.line_items.length <= 10"
                  class="elevation-1"
                >
                  <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td>{{ props.item.title }}</td>
                      <td>{{ props.item.sku }}</td>
                      <td>{{ (props.item.grams*props.item.quantity) | toOunces}}oz</td>
                      <td>${{ props.item.price }}</td>
                      <td class="text-xs-center">{{ props.item.quantity }}</td>
                    </tr>
                  </template>
                  <template slot="footer">
                    <td style="padding-left:15px;">
                    Total
                    </td>
                    <td class="text-xs-right" colspan="80%">
                      {{calculatedDetailsDraftTotal}}
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text v-if="!ui.loading && !details.draft.returns">
            Returned items have not been processed yet.
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</v-dialog>

</v-container>
</template>
<script>
import { db, functions } from '@/services/firebase.js'
import moment from 'moment'

export default {
    data () {
        return {
            ui: {
                loading: true,
                dialog: false,
                tab: null,
                voiding: false
            },
            headers: [
              { text: 'Tracking Code', align: 'left', value: 'tracking_code' },
              { text: 'Carrier', align: 'center', value: 'carrier' },
              { text: 'Status', align: 'center', value: 'status' },
              { text: 'Is Return', align: 'center', value: 'is_return' },
              { text: 'Est Delivery', align: 'center', value: 'est_delivery_date' },
              { text: 'Created', align: 'right', value: 'timestamp' },
            ],
            line_item_headers: [
              { text: 'Item', align: 'left', value: 'title' },
              { text: 'SKU', value: 'sku' },
              { text: 'Weight', value: 'weight', width: 20 },
              { text: 'Price', value: 'price', width: 20 },
              { text: 'Qty', value: 'quantity', width: 20 }
            ],
            trackers: [],
            pagination: {},
            totalTrackers: 1,
            docs: [],
            prevLastDoc: null,
            lastDoc: null,
            details: null
        }
    },
    filters: {
      toTimestamp: function(str){
         if (str === null) return 'N/A'
         return moment(str).format('MM/DD/YY hh:mm:ss A')
      },
      toUpperCase: function(str){
        return str.toUpperCase()
      },
      toOunces: function(grams) {
        return Math.ceil(grams * 0.0352739619)
      }
    },
    computed: {
      isAdmin () {
        return this.$store.getters.isAdmin !== null && this.$store.getters.isAdmin !== undefined
      },
      isManager () {
        return this.$store.getters.isManager !== null && this.$store.getters.isManager !== undefined
      },
      isDark: function () {
        return this.$vuetify.dark
      },
      calculatedDetailsDraftTotal: function () {
        var self = this
        if(self.details){
          var total = 0
          self.details.draft.line_items.forEach((item) => {
            total = total + (parseFloat(item.price) * item.quantity)
          })
          return '$' + total.toFixed(2)
        } else {
          return '$0.00'
        }
      }
    },
    watch: {
      pagination: {
        handler () {
          var self = this
          self.getTrackers()
            .then(data => {
              self.trackers = data
            })
        },
        deep: true
      }
    },
    methods: {
      getTrackers: function () {
        var self = this
        self.ui.loading = true
        return new Promise((resolve, reject) => {
          const { page, rowsPerPage } = self.pagination

          if (page !== 1) {

            db.collection("tracking").startAfter(self.docs[page*rowsPerPage-1]).limit(1).get()
            .then((snapshot) => {
              let trackers = []
              snapshot.docs.forEach((doc) => {
                self.docs.push(doc)
                trackers.push(doc.data())
              })
              //self.totalTrackers = snapshot.size < rowsPerPage ? (page * rowsPerPage) - snapshot.size  : (page * rowsPerPage)

              self.ui.loading = false
              resolve(trackers)            
            })
            .catch((err) => {
              self.ui.loading = false
              reject(err)
              console.error(err)
            })

          } else {

            db.collection("tracking").where('timestamp', '>=', self.timeframe('last_30_days').from).where('timestamp', '<=', self.timeframe('today').to).get()
            .then((snapshot) => {
              //console.log(snapshot)
              let trackers = []
              snapshot.docs.forEach((doc) => {
                self.docs.push(doc)
                trackers.push(doc.data())
              })
              //self.totalTrackers = snapshot.size < rowsPerPage ? (page * rowsPerPage) - snapshot.size  : (page * rowsPerPage)

              self.ui.loading = false
              resolve(trackers)            
            })
            .catch((err) => {
              self.ui.loading = false
              reject(err)
              console.error(err)
            })

          }
        })
      },
      setDetails: function (tracker) {
        var self = this
        self.ui.loading = true
        self.details = null
        self.details = tracker
        self.getDraft(tracker.draft_id)
        .then(() => {
          self.ui.loading = false
          self.ui.dialog = true
        })
        .catch((e) => {
          console.error(e)
          self.ui.loading = false
          self.ui.dialog = true
        })
      },
      getDraft: function (draft_id) {
        var self = this
        return new Promise((resolve, reject) => {
          db.collection("drafts").doc(draft_id.toString()).get()
          .then((doc) => {
            self.details.draft = doc.data()
            resolve()
          })
          .catch((err) => {
            console.error(err)
            reject()
          })
        })
      },
      timeframe: function(timeframe) {        
        if (timeframe === 'today') {
          return {from: moment.utc().startOf('day').valueOf(), to: moment.utc().endOf('day').valueOf()}
        }
        if (timeframe === 'yesterday') {
          return {from: moment.utc().subtract(1, 'days').startOf('day').valueOf(), to: moment.utc().subtract(1, 'days').endOf('day').valueOf()}
        }
        if (timeframe === 'last_7_days') {
          return {from: moment.utc().subtract(7, 'days').startOf('day').valueOf(), to: moment.utc().valueOf()}
        }
        if (timeframe === 'last_30_days') {
          return {from: moment.utc().subtract(30, 'days').startOf('day').valueOf(), to: moment.utc().valueOf()}
        }
      },
      voidTrackingLabel: function (label) {
        var self = this
        self.ui.voiding = true
        var voidTrackingLabel = functions.httpsCallable('voidTrackingLabel')
        voidTrackingLabel({ label_id: label.label.label_id, tracking_number: label.tracking_code })
        .then(() => {
          label.status = 'VOIDED'
          self.details = label
          self.getTrackers()
          self.ui.voiding = false
        })
        .catch((err) => {
          console.error(err)
        })
      }
    },
    mounted () {

    }
}
</script>
<style lang="stylus" scoped>
.theme--dark-old .v-card
  background #40525B!important
.theme--dark-old .v-datatable
  background-color #40525B!important
.theme--dark-old .v-datatable__actions
  background-color none!important
  background none!important
</style>